import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/criteriabovenlokaal/";

const CriteriaBovenlokaalApi = {
	get(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyBereikDoelgroep(dossierId, inTheFuture) {
		const serviceUrl = prependRoot(routePrefix + "empty/" + dossierId + "/" + inTheFuture, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(beoordelingscriteria, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.put(serviceUrl, {
			item: beoordelingscriteria,
			documenten
		}, {
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default CriteriaBovenlokaalApi;
